export const SystemAdmins = "systemadmins"
export const SuperAdmins = "superadmins"